import React from 'react';
import { FileTextIcon, CpuIcon, FileCheck2Icon, ArrowRightIcon } from 'lucide-react';
const nodes = [{
  icon: FileTextIcon,
  label: 'Prompt',
  sub: 'your instruction + your facts',
  tone: 'bg-white text-plum border-grape/20',
  iconTone: 'bg-lilac-soft text-grape'
}, {
  icon: CpuIcon,
  label: 'AI',
  sub: 'ChatGPT · Claude · Gemini',
  tone: 'bg-plum text-white border-plum',
  iconTone: 'bg-grape text-white'
}, {
  icon: FileCheck2Icon,
  label: 'Result',
  sub: 'draft ready for your review',
  tone: 'bg-white text-plum border-blush/30',
  iconTone: 'bg-blush-soft text-blush'
}];
export function PromptFlow() {
  return <div className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-center" aria-label="How a prompt works" data-id="element-241" data-mp="2zl0ltv5tp347">
      {nodes.map((n, i) => <React.Fragment key={n.label} data-id="element-242" data-mp="1567sy3wbqqfy" data-mpi={i}>
          <div className={`flex items-center gap-3 rounded-2xl border px-4 py-3 sm:w-52 ${n.tone}`} data-id="element-243" data-mp="157itluuh3i2u">
            <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${n.iconTone}`} data-id="element-244" data-mp="1a5kn79piyzsk">
              <n.icon className="h-5 w-5" data-id="element-245" data-mp="1f11kuto4tchx" />
            </span>
            <div className="min-w-0" data-id="element-246" data-mp="1a8qmhv91hyrh">
              <p className="font-display text-base font-black" data-id="element-247" data-mp="1a7p4f6tlwc09">{n.label}</p>
              <p className="truncate text-xs opacity-70" data-id="element-248" data-mp="15ap3197pbxfh">{n.sub}</p>
            </div>
          </div>
          {i < nodes.length - 1 && <ArrowRightIcon className="mx-auto h-5 w-5 rotate-90 text-grape sm:mx-0 sm:rotate-0" aria-hidden="true" data-id="element-249" data-mp="108zovkp6n3n6" />}
        </React.Fragment>)}
    </div>;
}